import React, { useState, useEffect } from "react";
import {
  List,
  ListItem,
  Divider,
  ListItemText,
  ListItemAvatar,
  Button,
  ListItemSecondaryAction,
  Avatar,
} from "@material-ui/core";
import { connect } from "react-redux";
import { ClearSharp, CheckOutlined, ArrowBackSharp } from "@material-ui/icons/";
import { assignOrder } from "../../../actions/sellerActions";

import Loading from "../../Loading";
import tcsImage from "../../../media/tcs.png";
import url from "../../../constants/URL";
const OrderAssignment = (props) => {
  const [loading, setLoading] = useState(true);
  const [deliveryboys, setDeliveryboys] = useState([]);

  useEffect(() => {
    if (props.seller.self_delivering) {
      getDeliveryboys();
    } else {
      setLoading(false);
    }
  }, []);

  async function getDeliveryboys() {
    const token = await JSON.parse(window.localStorage.getItem("persist:auth"))
      .token;
    fetch(`${url}/deliveryboys/${props.seller._id}/?all=${false}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }).then(async (resp) => {
      const boys = await resp.json();
      setDeliveryboys(boys);
      setLoading(false);
    });
  }

  if (!props.seller.self_delivering) {
    return (
      <>
        <ListItem alignItems="flex-start">
          <ListItemAvatar>
            <Avatar
              alt="avatar"
              src={tcsImage}
              style={{ objectFit: "contain" }}
            />
          </ListItemAvatar>
          <ListItemText primary={"TCS"} />
          <ListItemSecondaryAction>
            <Button
              variant="outlined"
              size="small"
              style={{
                color: "white",
                backgroundColor: "green",
                margin: "5px",
                borderRadius: "10px",
              }}
              onClick={() => {
                props.assignOrder(props.match.params.orderID, null, "tcs");
                props.history.push(`/dashboard/${props.seller._id}`);
              }}
            >
              <CheckOutlined />
            </Button>
          </ListItemSecondaryAction>
        </ListItem>
        <Divider />
      </>
    );
  }
  if (loading) {
    return <Loading />;
  }
  if (deliveryboys.length === 0) {
    return (
      <div style={{ heigth: "400px" }}>
        <Button onClick={() => props.history.goBack()}>
          <ArrowBackSharp />
        </Button>
        <div
          style={{
            textAlign: "center",
            color: "deepSkyBlue",
            display: "block",
            marginTop: "150px",
          }}
        >
          <ClearSharp style={{ fontSize: "100px" }} />
          <h2>No delivery boy available...</h2>
          <h2>Wait for them to finish the remaining orders</h2>
        </div>
      </div>
    );
  }

  return (
    <div>
      <List>
        <h3
          style={{
            color: "white",
            backgroundColor: "black",
            borderRadius: "20px",
            padding: "10px 0 10px 40px",
          }}
        >
          Available Delivery Boys
        </h3>
        {deliveryboys.map((boy, index) => {
          const { name, image, phoneNumber, _id } = boy;
          return (
            <React.Fragment>
              <ListItem alignItems="flex-start">
                <ListItemAvatar>
                  <Avatar
                    alt="avatar"
                    src={image}
                    style={{ objectFit: "contain" }}
                  />
                </ListItemAvatar>
                <ListItemText primary={name} secondary={phoneNumber} />
                <ListItemSecondaryAction>
                  <Button
                    variant="outlined"
                    size="small"
                    style={{
                      color: "white",
                      backgroundColor: "green",
                      margin: "5px",
                      borderRadius: "10px",
                    }}
                    onClick={() => {
                      props.assignOrder(props.match.params.orderID, _id);
                      props.history.push(`/dashboard/${props.seller._id}`);
                    }}
                  >
                    <CheckOutlined />
                  </Button>
                </ListItemSecondaryAction>
              </ListItem>
              <Divider />
            </React.Fragment>
          );
        })}
      </List>
    </div>
  );
};

const mapStateToProps = (state) => ({
  seller: state.auth.seller,
});

export default connect(mapStateToProps, { assignOrder })(OrderAssignment);
